import { ENV } from "../utils";

// Cliente de la API de notificaciones (server/router/notifications.js).
// Mismo patrón que el resto de client/src/api: fetch nativo, clase con
// baseApi, throw del `result` si el status no es 200.
export class Notifications {
  baseApi = ENV.BASE_API;

  async getMyNotifications(accessToken, limit = 20) {
    try {
      const url = `${this.baseApi}/notifications?limit=${limit}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getUnreadCount(accessToken) {
    try {
      const url = `${this.baseApi}/notifications/unread-count`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async markRead(accessToken, id) {
    try {
      const url = `${this.baseApi}/notifications/${id}/read`;
      const params = {
        method: "PATCH",
        headers: { Authorization: `Bearer ${accessToken}` },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async markAllRead(accessToken) {
    try {
      const url = `${this.baseApi}/notifications/read-all`;
      const params = {
        method: "PATCH",
        headers: { Authorization: `Bearer ${accessToken}` },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
